import { render, staticRenderFns } from "./SMenu.vue?vue&type=template&id=4b0c4ba8&"
import script from "./SMenu.vue?vue&type=script&lang=js&"
export * from "./SMenu.vue?vue&type=script&lang=js&"
import style0 from "./SMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports